import React, {useState, useEffect} from 'react'
import ArrowBack from '@material-ui/icons/ArrowBack'
import {Button, Typography, FormHelperText, Grid, Snackbar} from '@material-ui/core/'
import MuiAlert from '@material-ui/lab/Alert'
import FormBuilder from '../../components/FormBuilder'
import {Link} from 'react-router-dom'
import {useFormReducerHook} from '../../utils/customHooks'
import {useSettings} from '../../utils/Settings'
import Loader from '../../components/Loader'
import {forgotPasswordForm, forgotPasswordEmail} from '../../services/outReach'
import ForgotPasswordEmailSend from '../../components/ForgotPasswordEmailSend'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ForgotPassword = () => {
    const [forgotSuccess, setForgotSuccess] = useState(false)
    const [updateError, setUpdateError] = useState('')
    const [loading, setLoading] = useState(false)

    const [open, setOpen] = useState(false)
    const [sentEmailMessage, setEmailMessage] = useState('')
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
    } = useFormReducerHook()
    const {appConfig} = useSettings()

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'enterOnKeyUp':
                submitForm()
                break
            default:
                break
        }
    }

    const submitForm = async () => {
        setLoading(true)
        setUpdateError('')
        if (validate()) {
            setLoading(true)
            let inputSubmit = {...formData}
            inputSubmit = {
                loginname: (inputSubmit.loginname && inputSubmit.loginname.trim()) || '',
                emailaddress:
                    (inputSubmit.emailaddress && inputSubmit.emailaddress.trim()) || '',
            }
            const response = await forgotPasswordForm(inputSubmit)
            if (Object.entries(response.error).length > 0) {
                setUpdateError(response.error.message)
                setLoading(false)
            } else {
                setForgotSuccess(true)
                setLoading(false)
            }
        }
        setLoading(false)
    }

    const handleResend = async () => {
        const inputResend = {
            loginname: (formData.loginname && formData.loginname.trim()) || '',
            emailaddress: (formData.emailaddress && formData.emailaddress.trim()) || '',
        }
        const result = await forgotPasswordEmail(inputResend)
        if (Object.entries(result.error).length > 0) {
        } else {
            setEmailMessage(result.success.message)
            setOpen(true)
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    useEffect(() => {
        document.title = appConfig.pageTitle.forgotpassword
    }, [appConfig.pageTitle.forgotpassword])

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    return (
        <Grid item xs className="login__contanier forgot-password__contanier">
            <Snackbar
                open={open}
                autoHideDuration={3000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                onClose={handleClose}
            >
                <Alert severity="success">{sentEmailMessage}</Alert>
            </Snackbar>
            {forgotSuccess ? (
                <ForgotPasswordEmailSend
                    appConfig={appConfig}
                    onClickResend={handleResend}
                />
            ) : (
                <Grid item className="login__signin">
                    <Grid item className="login__head">
                        <Typography variant="h4" component="h2" className="login__title">
                            <Link to={loginPath} style={{textDecoration: 'none'}}>
                                <ArrowBack name="arrow left" size="large" />{' '}
                            </Link>

                            {
                                appConfig.supportedLabels.forgotPassword
                                    .forgotPasswordHeader
                            }
                        </Typography>
                    </Grid>
                    <Grid item xs className="login__form forgot-password__form">
                        <FormBuilder
                            fields={appConfig.forgotPasswordProps}
                            formData={formData}
                            setFormData={setFormData}
                            errorsData={errorsData}
                            updateValidation={updateValidationData}
                            onSubmit={submitForm}
                            actionMethods={actionMethods}
                        />

                        <FormHelperText error>{updateError}</FormHelperText>
                    </Grid>
                    <Grid item xs className="login__form-action">
                        <Grid item xs={12} className="loader__container">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={submitForm}
                                disabled={loading}
                            >
                                {appConfig.supportedLabels.forgotPassword.submitBtnTxt}
                            </Button>
                            {loading ? <Loader /> : null}
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Grid>
    )
}

export default ForgotPassword
